import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';

function SimpleNoticeCard({ content, className }: { content: string; className?: string }) {
  return (
    <div
      className={cn(
        'mb-10 flex w-full items-center justify-center rounded-[7px] border border-borderBg09 bg-colorBg21 py-5',
        className,
      )}
    >
      <img src={`${SettingConfig.S3_BUCKET_URL}/img/icon/ico_info.png`} alt='info' width={20} height={20} />
      <span className='ml-3 text-[#777] text-[15px]'>{content}</span>
    </div>
  );
}

export default SimpleNoticeCard;
